// Actions
import { ActionType } from "../ActionType";
import { AppErrorAction } from "./AppErrorAction";
import { AppErrorCode } from "@ms/uno-constants/lib/local/ErrorConstants";
export class DynamicImportFailureAction extends AppErrorAction {
    constructor(){
        super(ActionType.DynamicImportFailure, AppErrorCode.DynamicImportError);
    }
}
